import React from 'react'
import PropTypes from 'prop-types'

import UserExpenseListItem from "./UserExpenseListItem";


const UserExpenseList = ({data, onDownload, onEdit, onDelete}) => {

    return (
        <div className="d-flex flex-column">
            {data && data.map(expense => <UserExpenseListItem {...expense} onDownload={onDownload} onEdit={onEdit} onDelete={onDelete}/>)}
        </div>
    )

}

UserExpenseList.propTypes = {
    data: PropTypes.array
}

export default UserExpenseList